export function metronome(
    handler: (elapsed: number) => void,
    delay: number,
    options:
        | {
              tickOnce?: boolean;
              seed?: number;
          }
        | undefined = undefined,
): () => void {
    let timeout: NodeJS.Timeout;
    const startTime = Date.now();
    let lastTickTime = startTime;

    const tick = () => {
        lastTickTime = Date.now();

        const elapsed = lastTickTime - startTime;

        handler(elapsed + (options?.seed || 0));

        if (options?.tickOnce) {
            destroy();
        }
    };

    const sync = () => {
        const timeSinceLastTick = Date.now() - lastTickTime;
        if (timeSinceLastTick >= delay) {
            tick();
        }
    };

    const handleDocumentVisibilityChange = () => {
        if (document.visibilityState === 'visible') {
            sync();
        }
    };

    const handleWindowFocus = () => {
        sync();
    };

    if (options?.tickOnce) {
        timeout = setTimeout(() => tick(), delay);
    } else {
        timeout = setInterval(() => tick(), delay);
    }

    document?.addEventListener('visibilitychange', handleDocumentVisibilityChange);
    window?.addEventListener('focus', handleWindowFocus);

    const destroy = () => {
        clearTimeout(timeout);
        document?.removeEventListener('visibilitychange', handleDocumentVisibilityChange);
        window?.removeEventListener('focus', handleWindowFocus);
    };

    return destroy;
}
